import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[currencyFormatDirective]'
})
export class CurrencyFormatDirective {

  private decimalSeparator: string = ',';
  private thousandSeparator: string = '.';

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInputChange(event: any): void {
    const initialValue = this.el.nativeElement.value;
    this.el.nativeElement.value = this.formatCurrency(initialValue.replace(/[^0-9]/g, ''));
    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }

  private formatCurrency(value: string): string {
    if (!value) {
      return '';
    }

    // Ensure that the value is properly split into integer and decimal parts
    let integerPart = value.slice(0, -2);
    let decimalPart = value.slice(-2);

    if (decimalPart.length < 2) {
      decimalPart = '0' + decimalPart;  // Ensure decimal part always has two digits
    }

    // Format the integer part with thousand separators
    let result = '';
    let i = 0;
    const len = integerPart.length;

    for (i = 0; i < len; i++) {
      if (i !== 0 && (i % 3 === 0)) {
        result = this.thousandSeparator + result;
      }
      result = integerPart[len - i - 1] + result;
    }

    // Combine the formatted integer part with the decimal part
    result = result + this.decimalSeparator + decimalPart;

    return result;
  }
}